<template>
  <div class="flex w-full gap-1">
    <div
      v-for="i in 4"
      :key="i"
      class="h-1 flex-grow transition-colors"
      :class="{
        'bg-bgr-accent-primary': password && i - 1 <= score,
        '!bg-bgr-tertiary': i > score,
        'rounded-l-full': i === 1,
        'rounded-r-full': i === 4,
      }"
    />
  </div>
</template>

<script setup lang="ts">
  import { scorePassword } from "./logic";

  defineOptions({
    name: "PasswordStrengthBar",
  });

  const { password } = defineProps<{
    password: string;
  }>();

  const score = computed(() => {
    if (!password) {
      return 0;
    }
    return scorePassword(password);
  });
</script>
